export default __webpack_public_path__ + "static/media/discipline-agriculture.e964ef4b.svg";